import React from "react";
import Register from "../auth/Register";
import CommonAuthHeader from "./CommonAuthHeader";
import CommonHeader from "../CommonHeader";
import Text from "../text/Text";
import { useNavigate } from "react-router-dom";
import { signIn } from "../messages";
import { isTMA } from "../constants";

const OptionsRegister = () => {
  const navigate = useNavigate();

  const telegramAppSx = {
    backgroundColor: "white",
  };

  const webAppSx = {
    height: "100%",
  };

  const signInComponent = (
    <Text
      className="blue-text"
      font="bold"
      size={16}
      onClick={() => navigate("/login")}
      sx={{ cursor: "pointer" }}
    >
      {signIn}
    </Text>
  );
  return (
    <>
      <CommonHeader
        icon="backArrow"
        rightSideComponent={signInComponent}
        navigation="/"
      />
      <CommonAuthHeader
        showSpeedLogo={false}
        sx={isTMA() ? telegramAppSx : webAppSx}
      >
        <Register isFromOptions />
      </CommonAuthHeader>
    </>
  );
};

export default OptionsRegister;
